import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, RcmsJustificativaDesbloqueioAutomatico } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class RcmsJustificativaDesbloqueioAutomaticoService extends BaseResourceService<RcmsJustificativaDesbloqueioAutomatico> {

  constructor(
    protected injector: Injector
  ) {
    super(`rcms-justificativa-desbloqueio-automatico`, injector);
  }

}
